import { Button as MuiButton, styled } from '@mui/material'
import { ButtonProps } from './Button.types'

const StyledButton = styled(MuiButton)<{
  variant?: 'text' | 'outlined' | 'contained'
}>(({ theme, variant }) => ({
  textTransform: 'none',
  padding: '4px 16px',
  borderRadius: '3px',
  '& .MuiButton-startIcon': {
    width: '20px',
    height: '20px',
  },

  ...(variant === 'contained' && {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  }),

  ...(variant === 'outlined' && {
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      borderColor: theme.palette.primary.dark,
    },
  }),

  ...(variant === 'text' && {
    color: theme.palette.primary.main,
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  }),

  '&.Mui-disabled': {
    backgroundColor: 'transparent',
    color: theme.palette.action.disabled,
    border: `1px solid ${theme.palette.action.disabled}`,
    cursor: 'not-allowed',
  },
}))

export const Button = ({
  children,
  icon,
  disableRipple = true,
  label,
  sx = {},
  ...otherProps
}: ButtonProps) => {
  return (
    <StyledButton
      aria-label={label}
      disableRipple={disableRipple}
      startIcon={icon}
      sx={sx}
      {...otherProps}
    >
      {children}
    </StyledButton>
  )
}
